import React from 'react';

import { ParsedData, useQuery } from '@betterment/js-runtime';

import { TransitionaryGoal } from './data';

import { urlBuilder } from '../../Shared/urlBuilder';

export interface TransitionaryGoalsResponse {
  transitionaryGoals: TransitionaryGoal[];
}

export interface TransitionaryGoalContext {
  data: TransitionaryGoalsResponse | null;
  error: {} | null;
  loading: boolean;
  loadData: () => Promise<ParsedData<TransitionaryGoalsResponse>>;
}

export const TransitionaryGoalsContext = React.createContext<TransitionaryGoalContext | null>(null);

export const TransitionaryGoalsProvider: React.FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const {
    loading,
    data,
    errors: error,
    refetch: loadData,
  } = useQuery<TransitionaryGoalsResponse>(urlBuilder.getSummaryTransitionaryGoals());

  const values = React.useMemo(() => ({ data, error, loading, loadData }), [data, error, loading, loadData]);

  return <TransitionaryGoalsContext.Provider value={values}>{children}</TransitionaryGoalsContext.Provider>;
};

export const useTransitionaryGoals = (): TransitionaryGoalContext => {
  const context = React.useContext<TransitionaryGoalContext | null>(TransitionaryGoalsContext);
  if (!context) {
    throw new Error('useTransitionaryGoals must be used under TransitionaryGoalsProvider.');
  }
  return context;
};
